/**
 * @desc 同步订单到OMS
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/syncToOms`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
